<template>
  <div class="books-list">
    <div class="books-search">
      <div v-for="item in option" :key="item.id">
        <div
          @click="booksSearch(item)"
          :class="bookTypeCode === item.bookTypeCode ? 'books-button' : ''"
        >
          {{ item.bookTypeName }}
        </div>
      </div>
    </div>
    <div class="books-list-line"></div>
    <div class="books-list-title">相关书籍</div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多书籍了"
      :immediate-check="false"
      @load="onLoad"
    >
      <div class="list">
        <div v-for="item in list" :key="item.id">
          <img
            width="100%"
            @click="imagePreview(item.bookImage)"
            style="min-height:70%"
            height="70%"
            :src="item.bookImage"
            alt=""
            srcset=""
          />
          <div class="title">
            <span>【{{ item.bookCode }}】</span>{{ item.bookName }}
          </div>
          <div class="foot">
            <div
              class="button"
              v-if="item.borrowStatus == 1 && !item.isBorrower"
            >
              {{
                item.remainingDays > -1
                  ? `还剩${item.remainingDays || 0}天`
                  : `已逾期${Math.abs(item.remainingDays || 0)}天`
              }}
            </div>
            <div
              class="button"
              v-else-if="item.borrowStatus == 0"
              @click="borrowBook(1, item)"
              style="background: #fe5b2b"
            >
              借书
            </div>
            <div
              class="button"
              v-else-if="item.borrowStatus == 2"
              style="background: #fe5b2b"
            >
              还书待确认
            </div>
            <div
              class="button"
              v-else-if="item.borrowStatus == 1 && item.isBorrower"
              @click="borrowBook(2, item)"
              style="background: #fe5b2b"
            >
              还书
              <span v-if="item.remainingDays" style="font-size: 10px;">{{
                item.remainingDays > -1
                  ? `还剩${Math.abs(item.remainingDays || 0)}天`
                  : `已逾期${Math.abs(item.remainingDays || 0)}天`
              }}</span>
            </div>
            <div v-else></div>
            <van-icon
              name="chat-o"
              @click="borrowBook(3, item)"
              size="0.6rem"
            />
          </div>
        </div>
      </div>
    </van-list>
    <!-- 留言点赞 -->
    <van-popup class="books-borrow-wrapper" v-model="commonSthow">
      <van-form @submit="commonSubmit" ref="vanForm">
        <div class="books-common-price">
          <van-icon
            @click="like(1)"
            name="good-job-o"
            color="#C8A06C"
            size="0.6rem"
          />
          <div>{{ likeNum }}人点赞></div>
          <van-icon
            @click="like(0)"
            name="good-job-o"
            class="dislike"
            size="0.6rem"
          />
        </div>
        <van-field
          v-model="message"
          rows="5"
          autosize
          label=""
          type="textarea"
          label-width="60"
          maxlength="200"
          placeholder="请输入书评"
          show-word-limit
        />
        <div style="margin: 20px;">
          <van-button
            :loading="commonSubmitStatus"
            :disabled="!message"
            loading-text="提交..."
            round
            block
            type="info"
            native-type="submit"
          >
            提交
          </van-button>
        </div>
      </van-form>
    </van-popup>
    <!-- 借书 -->
    <van-popup class="books-borrow-wrapper" v-model="borrowShow">
      <div class="books-borrow-title">掌经阁运行管理办法</div>
      <div class="books-borrow-content">
        <p style="text-indent: 2em">
          为营造技术部良好的学习、交流氛围，提高图书利用率，特制定本制度；同时为能丰富“掌经阁”书籍，环保共享，倡导个人捐赠你觉得有价值的书籍。
        </p>
        <span>一、借阅流程：</span>
        <div>
          <p>
            1、“掌经阁”通过线上办理借阅流程后，于7F书柜处自取对应书籍，所有书籍须办理
            借阅手续，不可自行取走；
          </p>
          <p>
            2、每次借阅不得超过2本，单本借阅时间不超过45天；为便于管理，书籍不可续借，
            请借阅者务必在截止日前阅读完书籍；
          </p>
          <p>
            3、每位借阅人须按时归还书籍，不可逾期，如有逾期则按照0.5元/本/天收取逾期费，
            作为掌经阁后续扩建的基金；
          </p>
          <p>
            4、不得私自将书籍转借他人，他人如有借阅需求，请先在线归还并联系管理员确认归
            还后，再由他人重新借阅；
          </p>
          <p>
            5、借阅过程中，请借阅人务必爱护书籍，不得无故撕页、乱涂乱画、折叠、剪裁等，
            如出现书籍损坏情况，则取消其借阅书籍资格；
          </p>
          <p>
            6、借阅仅限于技术部在职员工，员工离职前需向图书对接BP核对是否有未归还书籍，
            并在离职前及时归还书籍;书籍无法归还者需按照原件赔偿。
          </p>
        </div>
        <span>二、捐书：</span>
        <div>
          <p>所捐书籍须经技术部HRBP审核，并编入“掌经阁”书库进行统一管理；</p>
        </div>
        <span>三、其他：</span>
        <div>
          <p>1、技术部HRBP每月10号前会对书籍进行清点规整；</p>
          <p>
            2、如员工个人有书籍推荐，可将书名、作者及推荐理由以邮件的形式发送至
            yuzhe.sun@zhangmen.com，会综合评估后进行汇总采买。
          </p>
        </div>
        <span>四、附则：</span>
        <div>
          <p>1、本制度适合公司技术部全体员工；</p>
          <p>2、本图书借阅制度自颁布之日起执行；</p>
          <p>3、本制度最终解释权归技术部HRBP所有。</p>
        </div>
        <div style="float: right;padding-top: 20px">
          <p>未来不远</p>
          <p style="padding-left: 10px;">2020.5</p>
        </div>
      </div>
      <van-checkbox class="books-borrow-promise" v-model="checked"
        >我已阅读并同意以上借书协议</van-checkbox
      >
      <div class="books-borrow-code">
        图书编号：<span>{{ nowObject.bookCode }}</span>
      </div>
      <div style="margin: 20px;">
        <van-button
          :loading="borrowSubmitStatus"
          loading-text="确定借书..."
          round
          block
          @click="borrowSubmit"
          :disabled="!checked"
          type="info"
          native-type="submit"
        >
          确定借书
        </van-button>
      </div>
    </van-popup>
    <!-- 还书 -->
    <van-popup class="books-borrow-wrapper" v-model="repayShow">
      <div class="books-repay-title">
        <img :src="repayIcon" height="26px" alt="" srcset="" />
        <div>请把书归还到指定的分类书架上并上传归还后照片</div>
      </div>
      <van-uploader
        v-model="fileList"
        class="upload-repay-image"
        :before-read="beforeRead"
        :after-read="afterRead"
        :max-count="1"
      />
      <div style="margin: 20px;">
        <van-button
          :loading="repaySubmitStatus"
          loading-text="确定还书..."
          :disabled="!fileList.length"
          round
          block
          @click="repaySubmit"
          type="info"
          native-type="submit"
        >
          确定还书
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  List,
  PullRefresh,
  Button,
  Icon,
  Dialog,
  Overlay,
  Form,
  Field,
  Toast,
  Checkbox,
  CheckboxGroup,
  Uploader,
  Popup,
  ImagePreview,
} from 'vant';
import axios from 'axios';
import {
  bookType,
  booksList,
  countStatistics,
  doPraise,
  doTrample,
  borrowBook,
  returnBook,
  addComment,
} from '../../api/books';

Vue.use(List)
  .use(PullRefresh)
  .use(Button)
  .use(Icon)
  .use(Dialog)
  .use(Overlay)
  .use(Form)
  .use(Field)
  .use(Toast)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Uploader)
  .use(Popup)
  .use(ImagePreview);

export default {
  data() {
    return {
      option: [],
      bookTypeCode: '',
      repayIcon:
        'https://web-data.zmlearn.com/image/781LMw8Tfy1jkDZJDTxYdL/borrow.png',
      commonSthow: false,
      borrowShow: false,
      repayShow: false,
      checked: false,
      commonSubmitStatus: false,
      borrowSubmitStatus: false,
      repaySubmitStatus: false,
      setTime: null,
      list: [],
      likeNum: 0,
      nowObject: '',
      loading: false,
      finished: false,
      fileList: [],
      message: '',
      params: {
        bookTypeCode: '',
        page: 0,
        pageSize: 10,
      },
    };
  },
  async mounted() {
    const res = await bookType({});
    this.option = [{ id: 0, bookTypeCode: '', bookTypeName: '全部' }, ...res];
    this.init();
  },
  methods: {
    async init() {
      const res = await booksList(this.params).catch(err => {
        Toast.fail('系统错误 请稍后再试');
        return (this.finished = true);
      });
      if (res) {
        res.content.forEach(r => {
          this.list.push(r);
        });
        if (res.last) return (this.finished = true);
      }
    },

    onLoad() {
      this.params.page++;
      setTimeout(async () => {
        this.loading = true;
        await this.init();
        this.loading = false;
      }, 1000);
    },

    async booksSearch(val) {
      this.params.bookTypeCode = val.bookTypeCode;
      this.bookTypeCode = val.bookTypeCode;
      this.params.page = 0;
      this.list = [];
      this.loading = true;
      this.finished = false;
      await this.init();
      this.loading = false;
    },

    async borrowBook(val, item) {
      this.nowObject = item;
      if (val === 1) {
        this.borrowSubmitStatus = false;
        this.checked = false;
        this.borrowShow = true;
      } else if (val === 2) {
        this.repaySubmitStatus = false;
        this.fileList = [];
        this.repayShow = true;
      } else {
        const res = await countStatistics({ bookCode: item.bookCode });
        if (res) {
          this.likeNum = res[0].value;
          this.commonSubmitStatus = false;
          this.message = '';
          this.commonSthow = true;
        }
      }
    },

    async commonSubmit() {
      this.commonSubmitStatus = true;
      const params = {
        bookCode: this.nowObject.bookCode,
        returnImage: this.message,
      };
      const res = await addComment(params).catch(err => {
        this.commonSubmitStatus = false;
        this.commonSthow = false;
        Toast.fail(err.message || '借书失败 请稍后再试');
      });
      this.commonSubmitStatus = false;
      this.commonSthow = false;
      Toast.success('书评成功');
    },

    async like(val) {
      try {
        val
          ? await doPraise({ bookCode: this.nowObject.bookCode })
          : await doTrample({ bookCode: this.nowObject.bookCode });
        const res = await countStatistics({
          bookCode: this.nowObject.bookCode,
        });
        this.likeNum = res[0].value;
      } catch (err) {
        Toast.fail('点赞失败请稍后再试');
      }
    },

    async borrowSubmit() {
      this.borrowSubmitStatus = true;
      borrowBook({ bookCode: this.nowObject.bookCode })
        .then(res => {
          this.borrowSubmitStatus = false;
          this.borrowShow = false;
          this.list.forEach(r => {
            if (r.bookCode === this.nowObject.bookCode) {
              r.borrowStatus = 1;
              r.isBorrower = true;
            }
          });
          Toast.success('借书成功');
        })
        .catch(err => {
          this.borrowSubmitStatus = false;
          this.borrowShow = false;
          Toast.fail(err.message || '借书失败 请稍后再试');
        });
    },

    repaySubmit() {
      if (this.fileList.length === 0) return Toast('请上传归还照片');
      this.repaySubmitStatus = true;
      const params = {
        bookCode: this.nowObject.bookCode,
        returnImage: this.fileList[0].url,
      };
      returnBook(params)
        .then(res => {
          this.repaySubmitStatus = false;
          this.repayShow = false;
          this.list.forEach(r => {
            if (r.bookCode === this.nowObject.bookCode) {
              r.borrowStatus = 2;
            }
          });
          Toast.success('我们已提醒管理员确认归还操作');
        })
        .catch(err => {
          this.repaySubmitStatus = false;
          this.repayShow = false;
          Toast.fail(err.message || '还书失败 请稍后再试');
        });
    },

    beforeRead(file) {
      if (file.size > 10 * 1204 * 1024) {
        Toast.fail('图片超出限制 请重新上传');
        return false;
      } else {
        return true;
      }
    },

    // 上传图片
    afterRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      this.setTime = setTimeout(() => {
        file.status = 'failed';
        file.message = '上传超时';
      }, 20000);
      const fd = new FormData();
      fd.append('uploadFile', file.file);
      axios
        .post('/api/book/oss/uploadFile', fd, {
          headers: {
            'Content-Type': 'multipart/form-data',
            token:
              process.env.VUE_APP_RUN_ENV === 'dev'
                ? 'aa-bb-cc,7,dingding'
                : window.sessionStorage.getItem('dingdingAuth'),
          },
        })
        .then(res => {
          clearTimeout(this.setTime);
          if (res.data.code == 0) {
            file.status = 'done';
            this.fileList = [{ url: res.data.data }];
          } else {
            file.status = 'failed';
            file.message = '上传失败';
          }
        })
        .catch(err => {
          clearTimeout(this.setTime);
          file.status = 'failed';
          file.message = '上传失败';
        });
    },

    // 查看大图
    imagePreview(url) {
      if (url) ImagePreview([url]);
    },
  },
};
</script>

<style lang="scss">
.books-list {
  font-size: 28px;
  min-height: 100vh;
  .books-list-line {
    height: 15px;
    background: #f3f3f3;
  }
  .books-list-title {
    font-weight: 500;
    color: #000;
    margin: 2.7% 0 0 2.7%;
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    > div {
      height: 500px;
      width: 46%;
      background: #fff;
      border-radius: 12px;
      margin: 2.7% 0 0 2.7%;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      overflow: hidden;
      img {
        border-radius: 12px 12px 0 0;
      }
      .title {
        min-height: 75px;
        height: 75px;
        font-size: 28px;
        color: #333;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        padding: 0 10px;
        span {
          margin-left: -10px;
        }
      }
      .foot {
        display: flex;
        justify-content: space-between;
        padding: 0 10px;
        align-items: center;
        height: 55px;
        .button {
          padding: 5px 10px;
          background: #1989fa;
          min-width: 80px;
          border-radius: 30px;
          color: #fff;
          font-size: 24px;
          text-align: center;
        }
      }
    }
  }
}
.books-search {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  font-size: 22px;
  // font-weight: 500;
  > div {
    width: 25%;
    overflow: hidden;
    > div {
      text-align: center;
      border: 1px solid #dcdfe6;
      color: #c8a06c;
      height: 50px;
      margin: 8px;
      line-height: 54px;
      border-radius: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
      /* autoprefixer: on */
    }
  }
  .books-button {
    background: #ff8302;
    color: #fff;
    border: 1px solid #ff8302;
  }
}
.books-common-price {
  padding: 30px;
  display: flex;
  align-content: center;
  > div {
    line-height: 0.7rem;
    padding: 0 30px 0 5px;
  }
  .dislike {
    transform: rotate(180deg);
  }
}
.books-repay-title {
  margin: 40px;
  line-height: 50px;
  border-radius: 30px;
  display: flex;
  padding: 15px 0;
  font-size: 24px;
  color: #9b9798;
}
.upload-repay-image {
  margin-left: 40px;
}
.books-borrow-wrapper {
  width: 90%;
  border-radius: 30px;
}
.books-borrow-wrapper {
  .books-borrow-title {
    text-align: center;
    margin: 40px 0;
    font-size: 32px;
    font-weight: 500;
    color: #000;
  }
  .books-borrow-content {
    padding: 0 40px;
    line-height: 50px;
    overflow-y: scroll;
    height: 55vh;
    span {
      font-weight: 500;
      color: #000;
      margin: 10px 0;
      display: inline-block;
    }
    div {
      padding-left: 56px;
    }
  }
  .books-borrow-promise {
    padding: 30px 40px 10px 40px;
  }
  .books-borrow-code {
    padding: 10px 45px 0 45px;
    font-size: 26px;
    color: #323233;
  }
}
</style>
